import type { TagFormData } from '@/types/tags'

export const normalizeTagPayload = (data: TagFormData) => {
    const trimmedName = data.name.trim()
    const trimmedColor = data.color.trim()

    return {
        name: trimmedName,
        color: trimmedColor.startsWith('#') ? trimmedColor : `#${trimmedColor}`,
        description: data.description?.trim() ?? '',
        inactive: Boolean(data.inactive),
    }
}
